module.exports = __webpack_public_path__ + "static/media/vault.94dc548e.svg";